

    // Reference to the global context (works on ES3 and ES5-strict mode)
    //jshint -W061, -W064
    module.exports = Function('return this')();





//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/GLOBAL.js
// module id = 387
// module chunks = 0 1 2